module.exports = __webpack_public_path__ + "static/media/image11.b017db0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mugen/image11.jpg
// module id = 1120
// module chunks = 0